<template>
  <div class="mt-auto mb-6">
    <div v-if="!isTasksOpen" class="hidden folder lg:block">
      <a @click.prevent="$emit('toggle')">
        <span>Unscheduled Tasks</span>
        <span class="small-counter">{{ tasks.length }}</span>
      </a>
    </div>
    <div v-if="isTasksOpen"
      class="flex my-2.5 mx-3 pointer pl-3 leading-10"
      @click.prevent="$emit('toggle')"
    >
      <h4 class="flex-1 font-semibold">Unscheduled Tasks</h4>
      <span class="text-xs text-gray-400">Close</span>
    </div>
    <div v-if="isTasksOpen" class="overflow-x-hidden h-auto calendar-view">
      <div class="flex py-0 px-2 my-0 mx-1 calendar-week-view">
        <draggable
          tag="div"
          class="flex-1"
          @change="onChange"
          :list="tasks"
          v-bind="{
            animation: 200,
            group: 'day-grid'
          }"
        >
          <div
            v-for="task in tasks" :key="task._id"
            class="event-item"
            :title="task.title"
            :style="{ 'border-right': `6px solid ${task.color}` }"
          >
            <div class="flex">
              <span class="flex-1">{{ task.title }}</span>
            </div>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  props: {
    tasks: Array,
    isTasksOpen: Boolean
  },
  components: {
    draggable
  },
  methods: {
    onChange(event) {
      if (event.added) {
        if (event.added.element.extras.type !== 'task') { return }
        if (event.added.element.extras.object.completed) { return }
        this.$emit('event-drop', { event: event.added.element, end: null })
      }
    }
  }
}
</script>
